import React from 'react';
import PropTypes from 'prop-types';

const Title = ({ actionType }) => {
  switch (actionType) {
  case 'allow':
    return <div className="text-center">Allow payment method</div>;

  case 'disallow':
    return <div className="text-center">Disallow payment method</div>;

  default:
    return null;
  }
};

Title.propTypes = {
  actionType: PropTypes.string,
};

export default Title;
